// @ts-strict-ignore
import { UndoApplyTextOperation } from './operation/undo-apply-text-operation';
import { ProjectModel } from '@project/model/project.model';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { UndoDetachArticlesOperation } from './operation/undo-detach-articles-operation';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { UndoAttachArticlesOperation } from './operation/undo-attach-articles-operation';
import { MetaElementUsageIdentityVO, TextValueVO } from '../vo/meta-element.vo';
import { Injectable } from '@angular/core';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { WireBridgeService } from '@project/components/article/manager/wire-bridge.service';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { UndoDetachBusbarArticlesOperation } from './operation/undo-detach-busbar-articles-operation';
import { UndoAttachBusbarArticlesOperation } from './operation/undo-attach-busbar-articles-operation';
import { ArticleLineHolder } from '@article/helper/article-line-holder';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

@Injectable({ providedIn: 'root' })
export class UndoRedoUtils {
  public static readonly ADD = 'ADD';
  public static readonly REMOVE = 'REMOVE';

  constructor(
    private _projectModel: ProjectModel,
    private _projectArticleService: ProjectArticleService,
    private _projectMetaElementService: ProjectMetaElementService,
    private _selectionModel: SelectionModel,
    private _selectionModelService: SelectionModelService,
    private _wireBridgeService: WireBridgeService,
    private _articleContainerLoader: ArticleContainerLoader,
    private _articleContainerFactory: ArticleContainerFactory,
    private _containerService: ContainerService,
    private _insertArticleUtils: InsertArticleUtils,
    private _articleContainerUtils: ArticleContainerUtils,
    private _applicationRefreshService: ApplicationRefreshService,
    private _detachArticleUsageService: DetachArticleUsageService,
    private _articleLineHolder: ArticleLineHolder,
    private _connectionInfoService: ConnectionInfoService
  ) {}

  public createUndoDetachOperationByUsageIds(articleUsageIds: string[]): UndoDetachArticlesOperation {
    return this.createUndoDetachOperationByArticleContainers(this._containerService.findArticleContainersInGlobalByGuids(articleUsageIds));
  }

  public createUndoDetachOperationByArticleContainers(articleContainers: ArticleContainer[]): UndoDetachArticlesOperation {
    if (!articleContainers || articleContainers.length === 0) {
      return null;
    }
    return new UndoDetachArticlesOperation(
      articleContainers,
      this._projectModel,
      this._projectArticleService,
      this._projectMetaElementService,
      this._selectionModel,
      this._selectionModelService,
      this._wireBridgeService,
      this._articleContainerLoader,
      this._articleContainerFactory,
      this._containerService,
      this._applicationRefreshService,
      this._detachArticleUsageService,
      this._insertArticleUtils
    );
  }

  public createUndoAttachOperationByUsageIds(articleUsageIds: string[]): UndoAttachArticlesOperation | null {
    return this.createUndoAttachOperationByArticleContainers(this._containerService.findArticleContainersInGlobalByGuids(articleUsageIds));
  }

  public createUndoAttachOperationByArticleContainers(articleContainers: ArticleContainer[]): UndoAttachArticlesOperation | null {
    if (!articleContainers || articleContainers.length === 0) {
      return null;
    }
    return new UndoAttachArticlesOperation(
      articleContainers,
      this._projectModel,
      this._projectArticleService,
      this._projectMetaElementService,
      this._selectionModel,
      this._selectionModelService,
      this._wireBridgeService,
      this._articleContainerLoader,
      this._articleContainerFactory,
      this._containerService,
      this._applicationRefreshService,
      this._detachArticleUsageService
    );
  }

  public createUndoDetachBusbarOperationByArticleContainers(busbarContainer: ArticleContainer): UndoDetachBusbarArticlesOperation | null {
    if (!busbarContainer) {
      return null;
    }
    return new UndoDetachBusbarArticlesOperation(
      busbarContainer,
      this._projectModel,
      this._projectArticleService,
      this._projectMetaElementService,
      this._selectionModel,
      this._selectionModelService,
      this._wireBridgeService,
      this._articleContainerLoader,
      this._articleContainerFactory,
      this._containerService,
      this._applicationRefreshService,
      this._detachArticleUsageService,
      this._articleLineHolder,
      this._connectionInfoService);
  }

  public createUndoAttachBusbarOperationByArticleContainers(busbarContainer: ArticleContainer): UndoAttachBusbarArticlesOperation {
    if (!busbarContainer) {
      return null;
    }
    return new UndoAttachBusbarArticlesOperation(
      busbarContainer,
      this._projectModel,
      this._projectArticleService,
      this._projectMetaElementService,
      this._selectionModel,
      this._selectionModelService,
      this._wireBridgeService,
      this._articleContainerLoader,
      this._articleContainerFactory,
      this._containerService,
      this._applicationRefreshService,
      this._detachArticleUsageService,
      this._articleLineHolder,
      this._connectionInfoService);
  }


  public createUndoApplyTextOperationByTextureAreaUsageIdentity(
    textureAreaUsageIdentity: MetaElementUsageIdentityVO,
    originalTextValue: TextValueVO,
    newTextValue: TextValueVO,
  ): UndoApplyTextOperation | null {
    if (!textureAreaUsageIdentity) {
      return null;
    }
    return new UndoApplyTextOperation(textureAreaUsageIdentity, originalTextValue, newTextValue, this._articleContainerUtils);
  }
}
